import React, {useState} from 'react';
import {Alert, Button, Card, Form, Input, message} from "antd";
import {LoadingOutlined, SaveOutlined} from "@ant-design/icons";
import {useDispatch, useSelector} from "react-redux";
import {useGetMeQuery, useLogoutMutation} from "../../../slices/rootApiSlices/authApiSlice";
import {usePasswordUpdateMutation} from "../../../slices/rootApiSlices/settingsApiSlice";
import {useNavigate} from "react-router-dom";
import {logout} from "../../../slices/authSlice";

const PasswordActions = () => {

    const dispatch = useDispatch()
    const navigate = useNavigate();
    const {user} = useSelector(state => state.auth);
    const {data, isLoading, error} = useGetMeQuery(user?.token);
    const [form] = Form.useForm();
    const [updateHandle] = usePasswordUpdateMutation()
    const [logoutHandle] = useLogoutMutation()
    const [oldPassword, setOldPassword] = useState("");
    const [newPassword, setNewPassword] = useState('');

    const onFinishFailed = (errorInfo) => {
        console.log('Failed:', errorInfo);
    };

    const onFinish = async () => {
        const userData = {
            oldPassword: form.getFieldValue("oldpassword"),
            newPassword: form.getFieldValue("newpassword")
        }
        try {
            const res = await updateHandle({token: user?.token, data: userData, id: data?.user?.id}).unwrap();
            if (res) {
                await logoutHandle(user?.token).unwrap()
                dispatch(logout())
                navigate('/auth/sign-in');
                message.success('Güncelleme işlemi başarılı.Lütfen yeni şifreniz ile oturum açınız..', 3)
            }
        } catch (e) {
            message.error('Güncelleme sırasında hata oluştu.Lütfen bir süre sonra tekrar deneyiniz', 3)
        }
    }

    if (isLoading) {
        return (
            <LoadingOutlined size="large" style={{flex: 1, alignItems: 'center', justifyContent: 'center'}}/>
        )
    }

    if (error) {
        return (
            <Alert
                showIcon
                style={{marginBottom: 10, width: 'auto'}}
                message="Sizin için geliştiriyoruz.Lütfen bir süre sonra tekrar deneyiniz.."
                type="error"
                closable={false}
            />
        )
    }

    return (
        <>
            <Alert
                showIcon
                style={{marginBottom: 10, width: 'auto'}}
                message="Şifre güncelleme işleminden sonra oturum otomatik olarak sonlandırılacaktır.Yeni şifre ile tekrar giriş yapabilirsiniz."
                type="warning"
                closable={false}
            />
            <Card size="small" type="inner" title="Şifre İşlemleri" style={{boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)'}}
                  bodyStyle={{padding: 10, height: 140}}>
                <Form
                    name="update-account-password"
                    onFinish={onFinish}
                    onFinishFailed={onFinishFailed}
                    autoComplete="off"
                    form={form}
                >
                    <Form.Item label="Eski Şifre / Yeni Şifre" style={{marginTop: 0}}>
                        <Form.Item
                            style={{display: 'inline-block', width: 'calc(50% - 8px)'}}
                            name="oldpassword"
                            rules={[
                                {
                                    required: true,
                                    message: 'Lütfen şifre giriniz!',
                                },
                            ]}
                        >
                            <Input.Password
                                placeholder="Şifre"
                                onChange={(e) => setOldPassword(e.target.value)}
                                value={oldPassword}
                                disabled={isLoading}
                            />
                        </Form.Item>
                        <Form.Item
                            style={{display: 'inline-block', width: 'calc(50% - 8px)', margin: '0 8px'}}
                            name="newpassword"
                            rules={[
                                {
                                    required: true,
                                    message: 'Lütfen şifreyi tekrar giriniz!',
                                }
                            ]}
                        >
                            <Input.Password
                                placeholder="Şifre tekrarı"
                                onChange={(e) => setNewPassword(e.target.value)}
                                value={newPassword}
                                disabled={isLoading}
                            />
                        </Form.Item>
                    </Form.Item>
                    <Form.Item style={{display: 'flex', justifyContent: 'flex-end', margin: '0 5px'}}>
                        <Button
                            disabled={isLoading || !oldPassword || !newPassword}
                            loading={isLoading}
                            type="primary"
                            htmlType="submit"
                            icon={<SaveOutlined/>}
                        >
                            Güncelle
                        </Button>
                    </Form.Item>
                </Form>
            </Card>
        </>

    );
};

export default PasswordActions;
